import { CssVarsProvider } from "@mui/joy";
import NavBar from "./WebPageComponents/NavBar";
import Branding from "./WebPageComponents/Branding";

const WebHomePage = () => {
	return (
		<CssVarsProvider>
			<div>
				<NavBar/>
				<Branding/>
			</div>
		</CssVarsProvider>
	)
}

export default WebHomePage;